import R from 'ramda';
import { createReducer } from 'ha/myredux/createReducer';
import { Actions } from '../constants';

export const initialState = {
  entities: [],
};

export default createReducer(
  {
    [Actions.LOAD_DONE]: (state, { citiesFeatured }) => ({
      ...state,
      entities: [...state.entities, ...citiesFeatured],
    }),
  },
  initialState,
);

export const getEntities = R.prop('entities');
